import { getLocalStorageItem } from '../localStorage';
import { capitalize } from '../misc';

export function receiptCompiler(data) {
  let finalData = [];
  data?.map((receipt) => {
    let receiptData = {
      url: receipt?.name?.replaceAll('/', '_'),
      id: receipt?.id,
      reference: receipt?.name,
      from: receipt?.location_id?.display_name,
      to: receipt?.location_dest_id?.display_name,
      invoice_no: receipt?.invoice_no || 'N/A',
      contact: receipt?.vendor_id ? receipt?.vendor_id?.name : receipt?.partner_id?.name || 'N/A',
      state: capitalize(receipt.state),
      lot: receipt?.lot_name || 'N/A',
      backorder_of: receipt?.backorder_id?.name || 'N/A',
      source_document: capitalize(receipt?.partner_ref) || receipt?.origin || 'N/A',
      schedule_date: receipt?.scheduled_date,
      deadline: receipt?.date_deadline,
      physical_container_no: receipt?.physical_container_no || 'N/A',
      finished_product: receipt?.finished_products || 'N/A',
      fill_received_quantity: receipt?.fill_received_quantity || false,
      received_quantity_filled: receipt?.received_quantity_filled || false,
      data: receipt,
    };
    finalData.push(receiptData);
  });
  return finalData;
}

export function receiptDetailCompiler({ moveIds, state, data }) {
  let finalData = [];
  const fill_received_quantity = data?.fill_received_quantity;
  moveIds?.map((move) => {
    let receiptDetailData = {
      id: move?.id,
      rolls: move?.no_of_rolls,
      done_rolls: move?.done_rolls,
      product: move?.product_id?.display_name,
      shipped_by_esun: move?.shipped_from_esun || 'N/A',
      lotNo:
        move?.product_id?.tracking === 'lot'
          ? move?.lot_ids?.length > 0
            ? move?.lot_ids?.[0]?.name
            : move?.move_line_ids?.[0]?.lot_name
          : 'N/A',
      demand_quantity: move?.product_uom_qty,
      dispatched_quantity: move?.dispatched_quantity,
      received_quantity: fill_received_quantity ? move?.received_quantity : move?.quantity,
      unit: move?.product_uom?.name,
      tracking: move?.product_id?.tracking,
      lot_ids: move?.lot_ids,
      move_line_ids: move?.move_line_ids,
      state: capitalize(state),
      // showEdit: move?.subcontract_has_been_recorded,
      damaged_quantity: move?.receipt_damage_qty,
      total_damaged_quantity: move?.total_receipt_damage_qty,
    };
    finalData.push(receiptDetailData);
  });
  return finalData;
}

export function receiptDetailBlpDataCompiler(data) {
  return data?.flatMap((move) =>
    move?.packages_ids?.map((pkg) => ({
      id: pkg?.id,
      name: pkg?.name,
    })) || []
  ) || [];
}

export function receiptDetailsBox(receipt) {
  const finalData = [
    { name: 'Destination Location', col: 1, data: receipt?.location_dest_id?.display_name },
    { name: 'Receive From', col: 1, data: receipt?.location_id?.display_name },
    { name: 'Invoice No', col: 1, data: receipt?.invoice_no || 'N/A' },
    { name: 'Scheduled Date', col: 2, data: receipt?.scheduled_date },
    { name: 'Deadline', col: 2, data: receipt?.date_deadline || 'N/A' },
    { name: 'Source', col: 2, data: capitalize(receipt?.partner_ref) || receipt?.origin || 'N/A' },
    { name: 'Backorder Of', col: 2, data: receipt?.backorder_id?.name || 'N/A' },
  ];
  const vendorType = getLocalStorageItem('vendor_type');
  if (vendorType === 'clothing' || vendorType === 'dyeing') {
    finalData.push({
      name: 'Finished Product',
      col: 2,
      data: receipt?.finished_products || 'N/A',
    });
  }
  if (vendorType === 'fabric' || vendorType === 'dyeing') {
    finalData.push({ name: 'Container No', col: 1, data: receipt?.physical_container_no || 'N/A' });
  }
  return finalData;
}
